import React, { Component } from "react";
import { AutoBind } from "../../rule-engine-core/Common/AutoBind";
import { Sidebar, SidebarItem } from "../../CommonUI/BuilderUI/Sidebar";
import { Topbar } from "../../CommonUI/BuilderUI/Topbar";

import { DataIcon } from "../../CommonUI/Icon/DataIcon";
import { RuleTableIcon } from "../../CommonUI/Icon/RuleTableIcon";

import { TestDataIcon } from "../../CommonUI/Icon/TestDataIcon";
import { ObserveState } from "../../CommonUI/StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { XExecutableTester } from "../../CommonUI/Testing/XExecutableTester";
import { RuleEditorDiv } from "../DesignUI/CommonStyles";
import { StatementRuleDesigner } from "./Builder/StatementRuleDesigner";
import { StatementRuleEditContext } from "./StatementRuleEditContext";
import { StatementRuleConfiguration } from "../../rule-engine-core/Rule/Statement/StatementRuleConfiguration";
import { RuleBuilderPage } from "../../rule-engine-core/Rule/RuleBuilderPage";
import { DataBuilder } from "../../DataBuilder/DataBuilder";
import { UnitTestConfiguration } from "../../rule-engine-core/Common/UnitTesting/UnitTestConfiguration";

export interface IStatementRuleEditor {
    ruleDefinition: StatementRuleConfiguration;
    statementRuleName?: string;
    onStatementRuleNameUpdate?: (newName: string) => void;
    onRuleSave?: () => void;
    onRuleCancel?: () => void;
    saveUnitTest?: (unitTest: UnitTestConfiguration) => void;
    getUnitTests?: () => Promise<UnitTestConfiguration[]>;
}

export class StatementRuleBuilder extends Component<IStatementRuleEditor, any> {
    editContext: StatementRuleEditContext;
    tabs: SidebarItem[];

    constructor(props: IStatementRuleEditor) {
        super(props);

        this.editContext = new StatementRuleEditContext(props.ruleDefinition);

        if (props.statementRuleName) {
            this.editContext.title = props.statementRuleName;
        }

        if (props.onRuleSave) {
            this.editContext.onRuleSave = props.onRuleSave;
        }

        if (props.onRuleCancel) {
            this.editContext.onRuleCancel = props.onRuleCancel;
        }

        this.tabs = this.getDefaultTabs();
    }

    @AutoBind
    onChangeRuleName(newName: string) {
        this.editContext.title = newName;
        StateManager.propertyChanged(this.editContext, "title");
        if (this.props.onStatementRuleNameUpdate) this.props.onStatementRuleNameUpdate(newName);
    }

    getDefaultTabs(): SidebarItem[] {
        return [
            {
                value: RuleBuilderPage.Rule,
                renderUI: () => (
                    <StatementRuleDesigner
                        editContext={this.editContext}
                        ruleDefinition={this.props.ruleDefinition}
                    />
                ),
                icon: <RuleTableIcon />,
            },
            {
                value: RuleBuilderPage.Data,
                renderUI: () => (
                    <DataBuilder
                        definition={this.props.ruleDefinition.getInputDefinition()}
                        readOnly={!this.props.ruleDefinition.canChangeInputs}
                    />
                ),
                icon: <DataIcon />,
            },
            {
                value: RuleBuilderPage.Test,
                renderUI: () => (
                    <XExecutableTester
                        saveUnitTest={this.props.saveUnitTest}
                        executable={this.props.ruleDefinition}
                    />
                ),
                icon: <TestDataIcon />,
            },
        ];
    }

    render() {
        return (
            <RuleEditorDiv>
                <ObserveState
                    listenTo={this.editContext}
                    properties={["title"]}
                    control={() => {
                        return (
                            <Topbar
                                onChangeName={this.onChangeRuleName}
                                editContext={this.editContext}
                                name={this.editContext.title}
                                isActionDisabled={!this.editContext.lastSelectionElement}
                                isRequiredActionGroup={false}
                                onSave={this.editContext.onSave}
                                onClose={this.editContext.onCancel}
                            />
                        );
                    }}
                />
                <ObserveState
                    listenTo={this.editContext}
                    properties={["mode"]}
                    control={() => (
                        <Sidebar
                            items={this.tabs}
                            value={this.editContext.mode}
                            onChange={(mode: string) => {
                                Reflect.set(this.editContext, "mode", mode);
                                StateManager.propertyChanged(this.editContext, "mode");
                            }}
                        />
                    )}
                />
            </RuleEditorDiv>
        );
    }
}
